import * as React from 'react';
import Input from 'components/form/Input';
import { InputProps } from 'components/form/Input/Input';
import { useFormContext, Controller } from 'react-hook-form';
import { getFileFromFirebase } from 'utils/firebase/storage';
import { FIREBASE_STORAGE_FILE_PATH } from 'utils/firebase/storage';

interface Props extends Omit<InputProps, 'name'> {
  name: string;
  handlePasswordChange?: (pw: string, isKnownPassword: boolean) => void;
}

const RHFInput: React.FC<Props> = props => {
  const { control } = useFormContext();
  const { handlePasswordChange, ...inputProps } = props;
  const [knownPasswords, setKnownPasswords] = React.useState<Array<string>>([]);

  React.useEffect(() => {
    const loadCommonPasswords = async () => {
      if (!knownPasswords?.length && inputProps.type === 'password')
        try {
          const passwords = await getFileFromFirebase(FIREBASE_STORAGE_FILE_PATH.COMMON_PASSWORDS);
          const passwordArray = passwords.split('\n');
          setKnownPasswords(passwordArray);
        } catch (e) {
          //
        }
    };

    loadCommonPasswords();
  }, [handlePasswordChange, knownPasswords?.length, inputProps]);

  const handleChange = (value: string, onChange: (value: string) => void) => {
    if (handlePasswordChange) {
      const isKnownPassword = knownPasswords.includes(value);
      handlePasswordChange(value, isKnownPassword);
    }
    onChange(value);
  };

  return (
    <Controller
      name={props.name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <Input
          {...field}
          onChange={value => handleChange(value, field.onChange)}
          error={!!error}
          helperText={error?.message}
          {...inputProps}
        />
      )}
    />
  );
};

export default RHFInput;
